export default {
  'pages.myApps.title': 'マイアプリ',
  'pages.myApps.description':
    '企業で利用可能な業務アプリを確認し、チームの業務を始めましょう。',
  'pages.myApps.backToCenter': 'アプリに戻る',
  'pages.myApps.refresh': '更新',
  'pages.myApps.browseMarket': 'アプリマーケットを見る',
  'pages.myApps.overview': 'アプリの概要',
  'pages.myApps.enabledCount': '有効なアプリ',
  'pages.myApps.availableCount': '開けるアプリ',
  'pages.myApps.unconfiguredCount': 'アクセス URL 未設定',
  'pages.myApps.currentPackage': '現在のプラン',
  'pages.myApps.packageError': 'プラン情報を読み込めませんでした。',
  'pages.myApps.retry': '再読み込み',
  'pages.myApps.subscription.active': '有効',
  'pages.myApps.subscription.expired': '期限切れ',
  'pages.myApps.subscription.suspended': '一時停止',
  'pages.myApps.subscription.cancelled': '解約済み',
  'pages.myApps.subscription.unknown': '状態情報なし',
  'pages.myApps.startsAt': '開始日',
  'pages.myApps.expiresAt': '有効期限',
  'pages.myApps.noExpiry': '有効期限なし',
  'pages.myApps.dateUnknown': '日付情報なし',
  'pages.myApps.noPackage':
    '現在のプランはありません。有効なアプリは引き続き利用できます。',
  'pages.myApps.appList': '有効なアプリ',
  'pages.myApps.accessDescription':
    'アプリは新しいウィンドウで開きます。アクセス URL が未設定のアプリはまだ開けません。',
  'pages.myApps.searchLabel': 'アプリを検索',
  'pages.myApps.searchPlaceholder': 'アプリ名または ID で検索',
  'pages.myApps.filterLabel': '有効化の方法で絞り込み',
  'pages.myApps.source.all': 'すべてのアプリ',
  'pages.myApps.source.package': 'プランに含まれる',
  'pages.myApps.source.tenant': '個別に有効化',
  'pages.myApps.source.other': 'その他',
  'pages.myApps.resultCount': '{count} 件のアプリが見つかりました',
  'pages.myApps.loadError': 'アプリ一覧を読み込めませんでした',
  'pages.myApps.loadErrorDescription':
    '再読み込みしてください。アプリの有効化記録には影響しません。',
  'pages.myApps.emptyTitle': 'まだ有効なアプリはありません',
  'pages.myApps.emptyDescription':
    'アプリマーケットで企業やチームに合う業務ツールを見つけましょう。',
  'pages.myApps.noResults': '一致するアプリがありません',
  'pages.myApps.noResultsDescription':
    '別のアプリ名や ID を試すか、検索と絞り込みを解除してください。',
  'pages.myApps.clearFilters': '絞り込みを解除',
  'pages.myApps.available': '開けます',
  'pages.myApps.unconfigured': 'アクセス URL 未設定',
  'pages.myApps.openApp': 'アプリを開く',
  'pages.myApps.openAppAccessible': '{name}を開く（新しいウィンドウ）',
  'pages.myApps.newWindow': '新しいウィンドウ',
  'pages.myApps.accessUnavailable': 'まだ開けません',
  'pages.myApps.paginationTotal': '全 {total} 件のアプリ',
};
